import { useState, useEffect } from "react";
import UpperLayerTabLayout from "../../../Components/DetailsPageUpperLayer/UpperLayerTabLayout";

const InboundShipmentHeader = ({ hProps, linesData }) => {
  const [shipmentDetails, setShipmentDetails] = useState({});
  const [freightDetails, setFreightDetails] = useState({});
  const [trackAndTraceData, setTrackAndTraceData] = useState({});

  const fieldLabels = {
    incoterm: "Incoterm Location",
    legEta: "Leg ETA",
    legPta: "Leg PTA",
  };

  useEffect(() => {
    // Keys you want to ALWAYS show under "Shipment"
    const shipmentKeys = [
      "shipmentNo",
      //"headerTrackingReference",
      "headerTrackingReferenceType",
      "shipmentType",
      "countryOfOrigin",
      "plannedShipDate",
      //"scacCode",
      //"containsHazmat",
      //"shipperRefNo",
      "processType",
      "creationDate",
      "supplier",
      "orderType",
      "customer",
    ];
    // Keys you want to ALWAYS show under "Transportation"
    // Based on swagger (excluding fkLink + shipmentKeys)
    const transportationKeys = [
      "shipMode",
      "numberOfContainers",
      "consigneeRefNo",
      //"consignee",
      "carrier",
      //"departurePort",
      //"arrivalPort",
      //"bookingNo",
      "incoterm",
      //"imo",
      //"freightForwarder",
      //"freightType",
      "namedPlace",
    ];

    const seedWithDefaults = (src, keys) =>
      keys.reduce((acc, k) => {
        acc[k] = src?.[k] ?? null;      // null
        return acc;
      }, {});

    // Build objects with fixed schemas so labels always render
    let shipmentDetails = seedWithDefaults(hProps || {}, shipmentKeys);
    let freightDetails = seedWithDefaults(hProps || {}, transportationKeys);

    shipmentDetails = {
      ...shipmentDetails,
      headerTrackingReferenceType: 'Tracking',
      shipmentType: 'Inbound Shipment',
      processType: 'Supply',
    };

    freightDetails = {
      ...freightDetails,
      numberOfContainers: 1,
      consigneeRefNo: hProps.consignee
    };

    setShipmentDetails(shipmentDetails);
    setFreightDetails(freightDetails);

    // Track & Trace
    setTrackAndTraceData({
      shipFrom: linesData?.[0]?.ship_from ?? null,
      shipTo: linesData?.[0]?.ship_to ?? null,
      //shipDate: linesData?.[0]?.container_ship_date ?? null,
      legEta: linesData?.[0]?.container_eta ?? null,
      //legPta: linesData?.[0]?.container_pta ?? null,
    });
  }, [hProps, linesData]);

  return (
    <UpperLayerTabLayout
      firstHeading="Shipment"
      secondHeading="Transportation"
      thirdHeading="Track & Trace"
      firstBoxData={shipmentDetails}
      secondBoxData={freightDetails}
      thirdBoxData={trackAndTraceData}
      showTrackAndTrace={true}
      fkLink={hProps?.fkLink}
      title="Inbound Shipments Detail"
      fieldLabels={fieldLabels}
    />
  );
};

export default InboundShipmentHeader;